import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "main-content-container overflow-hidden" }
const _hoisted_2 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_3 = { class: "card-body p-4" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-lg-6 col-md-6 mb-4" }
const _hoisted_6 = { class: "col-lg-6 col-md-6 mb-4" }
const _hoisted_7 = { class: "col-lg-4 col-md-4 mb-4" }
const _hoisted_8 = { class: "col-lg-4 col-md-4 mb-4" }
const _hoisted_9 = { class: "col-lg-4 col-md-4 mb-4" }
const _hoisted_10 = { class: "col-lg-6 col-md-6 mb-4" }
const _hoisted_11 = { class: "d-flex align-items-center gap-2 mb-2" }
const _hoisted_12 = {
  class: "rounded-3 border d-flex align-items-center justify-content-center bg-light text-primary",
  style: {"width":"45px","height":"45px","flex-shrink":"0"}
}
const _hoisted_13 = { class: "material-symbols-outlined fs-24" }
const _hoisted_14 = { class: "d-flex gap-1 flex-wrap" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "material-symbols-outlined fs-14" }
const _hoisted_17 = { class: "col-lg-6 col-md-6 mb-4" }
const _hoisted_18 = { class: "d-flex gap-1 flex-wrap" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { class: "col-lg-12 mb-4" }
const _hoisted_21 = { class: "col-lg-12 col-md-12 mb-4" }
const _hoisted_22 = { class: "form-check form-switch mt-2" }
const _hoisted_23 = { class: "col-lg-12 col-md-12 mb-4" }
const _hoisted_24 = { class: "form-label text-dark fs-14 fw-medium d-flex justify-content-between align-items-center" }
const _hoisted_25 = {
  class: "text-secondary fw-bold mt-2",
  style: {"width":"30px"}
}
const _hoisted_26 = ["onUpdate:modelValue"]
const _hoisted_27 = ["onClick", "disabled"]
const _hoisted_28 = { class: "d-flex justify-content-end gap-2" }
const _hoisted_29 = ["disabled"]
const _hoisted_30 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2",
  role: "status",
  "aria-hidden": "true"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageTitle = _resolveComponent("PageTitle")!
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageTitle, {
      pageTitle: _ctx.isEditing ? 'Edit Blog Post' : 'Add Blog Post',
      subTitle: "Management"
    }, null, 8, ["pageTitle"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("form", {
          onSubmit: _cache[11] || (_cache[11] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _cache[12] || (_cache[12] = _createElementVNode("label", { class: "form-label text-dark fs-14 fw-medium" }, "Title", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.title) = $event)),
                placeholder: "Enter post title",
                required: "",
                onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.autoSlug && _ctx.autoSlug(...args)))
              }, null, 544), [
                [_vModelText, _ctx.form.title]
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _cache[13] || (_cache[13] = _createElementVNode("label", { class: "form-label text-dark fs-14 fw-medium" }, "Slug (URL Path)", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.slug) = $event)),
                placeholder: "e.g. bahaya-plagiarisme-skripsi",
                required: ""
              }, null, 512), [
                [_vModelText, _ctx.form.slug]
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _cache[14] || (_cache[14] = _createElementVNode("label", { class: "form-label text-dark fs-14 fw-medium" }, "Category", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.category) = $event)),
                placeholder: "e.g. Plagiarisme, Tutorial",
                required: ""
              }, null, 512), [
                [_vModelText, _ctx.form.category]
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _cache[15] || (_cache[15] = _createElementVNode("label", { class: "form-label text-dark fs-14 fw-medium" }, "Publication Date", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.date) = $event)),
                placeholder: "e.g. 19 Juli 2026",
                required: ""
              }, null, 512), [
                [_vModelText, _ctx.form.date]
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _cache[16] || (_cache[16] = _createElementVNode("label", { class: "form-label text-dark fs-14 fw-medium" }, "Read Time", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.read_time) = $event)),
                placeholder: "e.g. 5 menit baca",
                required: ""
              }, null, 512), [
                [_vModelText, _ctx.form.read_time]
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _cache[17] || (_cache[17] = _createElementVNode("label", { class: "form-label text-dark fs-14 fw-medium" }, "Material Icon", -1)),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.form.icon || 'help'), 1)
                ]),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.icon) = $event)),
                  placeholder: "Type icon name or click preset below",
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.form.icon]
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.iconPresets, (ico) => {
                  return (_openBlock(), _createElementBlock("button", {
                    type: "button",
                    key: ico,
                    class: "btn btn-sm btn-outline-secondary fs-12 py-1 px-2 d-flex align-items-center gap-1",
                    onClick: ($event: any) => (_ctx.form.icon = ico)
                  }, [
                    _createElementVNode("span", _hoisted_16, _toDisplayString(ico), 1),
                    _createElementVNode("span", null, _toDisplayString(ico), 1)
                  ], 8, _hoisted_15))
                }), 128))
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _cache[18] || (_cache[18] = _createElementVNode("label", { class: "form-label text-dark fs-14 fw-medium d-flex justify-content-between" }, [
                _createElementVNode("span", null, "Card Background Gradient"),
                _createElementVNode("span", { class: "text-muted fs-12" }, "Click presets below or type custom CSS")
              ], -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control mb-2",
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.bg) = $event)),
                placeholder: "linear-gradient(135deg,#5f35f5,#7b5cf8)",
                required: ""
              }, null, 512), [
                [_vModelText, _ctx.form.bg]
              ]),
              _createElementVNode("div", _hoisted_18, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bgPresets, (p) => {
                  return (_openBlock(), _createElementBlock("button", {
                    type: "button",
                    key: p.name,
                    class: "btn btn-sm text-white fs-12 border-0",
                    style: _normalizeStyle([{ background: p.gradient }, {"padding":"2px 6px"}]),
                    onClick: ($event: any) => (_ctx.form.bg = p.gradient)
                  }, _toDisplayString(p.name), 13, _hoisted_19))
                }), 128))
              ])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _cache[19] || (_cache[19] = _createElementVNode("label", { class: "form-label text-dark fs-14 fw-medium" }, "Excerpt (Short description for listing)", -1)),
              _withDirectives(_createElementVNode("textarea", {
                class: "form-control",
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.excerpt) = $event)),
                rows: "2",
                placeholder: "Enter short summary...",
                required: ""
              }, null, 512), [
                [_vModelText, _ctx.form.excerpt]
              ])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  id: "isActive",
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.is_active) = $event))
                }, null, 512), [
                  [_vModelCheckbox, _ctx.form.is_active]
                ]),
                _cache[20] || (_cache[20] = _createElementVNode("label", {
                  class: "form-check-label text-dark fs-14 fw-medium",
                  for: "isActive"
                }, "Active Status (Visible to users)", -1))
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("label", _hoisted_24, [
                _cache[22] || (_cache[22] = _createElementVNode("span", null, "Content Paragraphs", -1)),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-sm btn-outline-primary py-1 px-2",
                  onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.addParagraph && _ctx.addParagraph(...args)))
                }, _cache[21] || (_cache[21] = [
                  _createElementVNode("i", { class: "ri-add-line me-1" }, null, -1),
                  _createTextVNode("Add Paragraph ")
                ]))
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.content, (p, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "d-flex mb-3 align-items-start gap-2"
                }, [
                  _createElementVNode("span", _hoisted_25, "#" + _toDisplayString(index + 1), 1),
                  _withDirectives(_createElementVNode("textarea", {
                    class: "form-control",
                    "onUpdate:modelValue": ($event: any) => ((_ctx.form.content[index]) = $event),
                    rows: "3",
                    placeholder: "Enter paragraph content...",
                    required: ""
                  }, null, 8, _hoisted_26), [
                    [_vModelText, _ctx.form.content[index]]
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-outline-danger p-2 lh-1 mt-1",
                    onClick: ($event: any) => (_ctx.removeParagraph(index)),
                    disabled: _ctx.form.content.length <= 1
                  }, _cache[23] || (_cache[23] = [
                    _createElementVNode("i", { class: "material-symbols-outlined fs-18" }, "delete", -1)
                  ]), 8, _hoisted_27)
                ]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_28, [
            _createVNode(_component_RouterLink, {
              to: "/blog-posts",
              class: "btn btn-secondary fs-15 fw-medium"
            }, {
              default: _withCtx(() => _cache[24] || (_cache[24] = [
                _createTextVNode("Cancel")
              ])),
              _: 1
            }),
            _createElementVNode("button", {
              type: "submit",
              class: "btn btn-primary fs-15 fw-medium",
              disabled: _ctx.loading
            }, [
              (_ctx.loading)
                ? (_openBlock(), _createElementBlock("span", _hoisted_30))
                : _createCommentVNode("", true),
              _createTextVNode(" " + _toDisplayString(_ctx.isEditing ? 'Update Post' : 'Create Post'), 1)
            ], 8, _hoisted_29)
          ])
        ], 32)
      ])
    ])
  ]))
}